import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';
import {TranslateService} from "@ngx-translate/core";
import {SessionService} from "../services/session.service";
import {Utils} from "../model/Utils";


@Pipe({
    name: 'myDateFormat'
})

export class MyDateFormat implements PipeTransform {
    constructor(private translate: TranslateService, private session: SessionService) {}

    transform(value: any, format?: string, noDateString?: string): any {
      // console.log('format: ' + format + ' noDateString: ' + noDateString)
        if (value) {
            const date = value instanceof Date ? value : new Date(value);
            let frLang = false;
            //fr-fr, fr-ca, fr-be, fr-ch....
            if (this.translate.instant('LanguageCode').toString().indexOf('fr')===0){
              frLang = true;
            }
            // console.log('moment.locale: ' + moment.locale());
            if (Utils.isNullOrUndefined(format)){
              return moment(date).format('YYYY MM DD');
            }
            switch(format){
              case 'j':
                if (frLang){
                  return moment(date).format('D MMM');
                }else{
                  return moment(date).format('MMM Do');
                }
              case 'jj':
                if (frLang){
                  return moment(date).format('ddd DD MMM');
                }else{
                  return moment(date).format('ddd MMM DD');
                }
              case 'jjY':
                if (frLang){
                  return moment(date).format('ddd DD MMM YYYY');
                }else{
                  return moment(date).format('ddd MMM DD YYYY');
                }
              case 'jjj':
                let fmtToUse = 'dddd MMMM DD';
                if (frLang){
                  fmtToUse =  'dddd DD MMMM';
                }
                if (!this.session.userInfo.isAMPM()){
                  fmtToUse += ' LTS';
                }else{
                  if (this.session.hideAMPMTemporary){
                    fmtToUse += ' hh:mm:ss';
                  }else{
                    fmtToUse += ' hh:mm:ss A';
                  }
                }
                return moment(date).format(fmtToUse);
              case 'jjjj':
                if (frLang){
                  return moment(date).format('dddd DD MMMM');
                }else{
                  return moment(date).format('dddd MMMM DD');
                }
              case 'jjjjj':
                if (frLang){
                  return moment(date).format('dddd DD MMMM YYYY');
                }else{
                  return moment(date).format('dddd MMMM DD YYYY');
                }
              case 'LT':    // Default LT format is 8:30 AM and not 08:30 AM
                if (!this.session.userInfo.isAMPM()){
                    return moment(date).format('kk:mm');
                }else if (this.session.hideAMPMTemporary){
                    return moment(date).format('kk:mm');
                }else{
                    return moment(date).format('hh:mm A');
                }

                /*
                if (!this.session.userInfo.isAMPM()){
                   // console.log('Asked for LT and is not AMPM');
                   //  return moment(date).format('hh:mm');
                  return moment(date).format('LT');
                }else{
                    if (this.session.hideAMPMTemporary){
                        console.log('Asked for LT and IS AMPM, hide AMPM');
                        return moment(date).format('hh:mm');
                    }else{
                        console.log('Asked for LT and IS AMPM!');
                        return moment(date).format('hh:mm A');
                    }
                }
                
                 */
              default:
                if (format) {
                  return moment(date).format(format);
                } else {
                  return moment(date).format('YYYY MM DD');
                }
            }

        }else{
          if (noDateString){
            return noDateString;
          }else{
            return '';
          }
        }
    }
}
